import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { flattenLegacyUrl } from '@app/core/routing/role-home';

/** Redirects `/admin/...` (and other role prefixes) to flat URLs. */
export function legacyRolePrefixRedirect(prefix: string): CanActivateFn {
  return (_route, state) => {
    const router = inject(Router);
    const target = flattenLegacyUrl(prefix, state.url);
    void router.navigateByUrl(target);
    return false;
  };
}
